// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.drag__holder {\n  background-color: #FAFAFA !important;\n}\n.drag__cb label.v-label {\n  font-size: 11px !important;\n}\n.drag-handle {\n  cursor: grab;\n}\n.drag-handle:active {\n  cursor: grabbing;\n}\n.drag-ghost {\n  opacity: 0.6;\n}\n", ""]);
// Exports
module.exports = exports;
